export const convertToTitle = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str
    .replace(/-+/g, ' ')
    .trim()
    .replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};
